export default "__VITE_ASSET__12f6a776__"